import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=30990b48&scoped=true"
import script from "./image-preview.vue?vue&type=script&lang=js"
export * from "./image-preview.vue?vue&type=script&lang=js"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=30990b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30990b48",
  null
  
)

export default component.exports